import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id C08498C1-E43B-4E79-817C-121AD2827689
 * name code-brackets
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/code-brackets.svg
 * tags
 * - Developer / Languages 
 * - Math 
 */
export const CodeBracketsIcon = createSvgIcon(<><path d="M15,4V6H18V18H15V20H20V4M4,4V20H9V18H6V6H9V4H4Z" /></>, 'CodeBracketsIcon');
export default CodeBracketsIcon